import { storageHelper } from '../../helpers/storage';

// Per-browser-session guard so a successful login is recorded at most once per user, even
// across page refreshes (a refresh re-mounts the app but keeps sessionStorage). Cleared on
// logout so the next sign-in in the same tab is recorded again. All access is best-effort —
// telemetry must never break the login UX.

const STORAGE_KEY = 'recordedLoginUserIds';

function readRecordedLoginUserIds(): string[] {
  try {
    const ids = storageHelper.session.getItem(STORAGE_KEY);
    return Array.isArray(ids) ? (ids as string[]) : [];
  } catch {
    return [];
  }
}

export function hasRecordedLoginThisSession(userId: string): boolean {
  return readRecordedLoginUserIds().includes(userId);
}

export function markLoginRecordedThisSession(userId: string): void {
  try {
    const ids = readRecordedLoginUserIds();
    if (!ids.includes(userId)) {
      storageHelper.session.setItem(STORAGE_KEY, [...ids, userId]);
    }
  } catch {
    /* ignore storage errors */
  }
}

export function clearRecordedLoginUserIds(): void {
  try {
    storageHelper.session.removeItem(STORAGE_KEY);
  } catch {
    /* ignore storage errors */
  }
}
